import React from 'react';
import { CDN_URLS } from '../config/cdn';
import CircularGallery from '../CircularGallery/CircularGallery';

const Domain = () => {
  const usecases = [
    {
      image: CDN_URLS.usecase.aiCompanion,
      text: 'AI companion'
    },
    {
      image: CDN_URLS.usecase.aiRobot,
      text: 'AI Companion Robots'
    },
    {
      image: CDN_URLS.usecase.aiIP,
      text: 'AI IP Character Avators'
    },
    {
      image: CDN_URLS.usecase.aiRolePlay,
      text: 'AI Roleplay'
    },
    {
      image: CDN_URLS.usecase.aiEdu,
      text: 'AI Education'
    },
    {
      image: CDN_URLS.usecase.aiTherapy,
      text: 'AI Therapy & Wellness'
    },
    {
      image: CDN_URLS.usecase.aiCreation,
      text: 'AI Creation'
    },
    {
      image: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&h=600&fit=crop&crop=center',
      text: 'More'
    }
  ];

  return (
    <section id="usecases" className="domain">
      <div className="section-header" style={{marginBottom: '0px'}}>
        <h2><img src="/local/memu-logo.svg" alt="MemU" style={{height: '1.2em', verticalAlign: 'middle', marginLeft: '0.2em', marginTop: '-0.2em'}} /> use cases</h2>
        <p>Discover how memU can be applied to your applications.</p>
      </div>
      <div className="gallery-container">
        <CircularGallery 
          items={usecases}
          bend={2}
          textColor="#333333"
          borderRadius={0.08}
          font="bold 24px -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          scrollSpeed={1.5}
          scrollEase={0.08}
        />
      </div>
    </section>
  );
};

export default Domain;